import React from 'react'
import { DefinedRange } from 'react-date-range'
import moment from 'moment'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

import { customStaticRanges } from '../helpers'

export const DateRangePickerDefinedReusable = ({ startDate, endDate, error = false, ...props }) => {
  return (
    <InteractiveTooltip
      clickable
      placement="bottom-start"
      theme="light"
      content={
        <DefinedRange
          ranges={[
            {
              startDate: moment(startDate).toDate(),
              endDate: moment(endDate).toDate(),
              key: 'selection',
            },
          ]}
          maxDate={moment().toDate()}
          editableDateInputs
          dateDisplayFormat="MM/dd/yyyy"
          staticRanges={customStaticRanges}
          inputRanges={[]}
          startDatePlaceholder=""
          endDatePlaceholder=""
          {...props}
        />
      }
    >
      <Button type="button" basic fullWidth className={classNames('date-filter', { error })}>
        <strong>{moment(startDate).format('L')}</strong>
        <span>to</span>
        <strong>{moment(endDate).format('L')}</strong>
      </Button>
    </InteractiveTooltip>
  )
}
